export const boxesOverlap = (
  x1,
  y1,
  x2,
  y2,
  width2,
  height2,
  width1 = 32,
  height1 = 32,
) => {
  return (
    x1 < x2 + width2 &&
    x1 + width1 > x2 &&
    y1 < y2 + height2 &&
    y1 + height1 > y2
  );
};

export function shrinkOverlap(
  x1, y1,
  x2, y2,
  size1 = 32, size2 = 32,
  pad1 = 8, pad2 = 8
) {
  const ax = x1 + pad1;
  const ay = y1 + pad1;
  const aw = size1 - pad1 * 2;
  const ah = size1 - pad1 * 2;

  const bx = x2 + pad2;
  const by = y2 + pad2;
  const bw = size2 - pad2 * 2;
  const bh = size2 - pad2 * 2;

  return (
    ax < bx + bw &&
    ax + aw > bx &&
    ay < by + bh &&
    ay + ah > by
  );
}
export function shrinkRectOverlap(
  x1, y1, w1, h1,
  x2, y2, w2, h2,
  pad1x = 0, pad1y = 0, pad2x = 0, pad2y = 0,
) {
  const ax = x1 + pad1x;
  const ay = y1 + pad1y;
  const aw = w1 - pad1x * 2;
  const ah = h1 - pad1y * 2;

  const bx = x2 + pad2x;
  const by = y2 + pad2y;
  const bw = w2 - pad2x * 2;
  const bh = h2 - pad2y * 2;

  return (
    ax < bx + bw &&
    ax + aw > bx &&
    ay < by + bh &&
    ay + ah > by
  );
}

export const rockOverlap = (
  x1, y1,        // player top-left
  x2, y2,        // rock top-left
  rockSize = 12,
  playerSize = 32,
  padRock = 2,   // cut 2px off each side of rock
  padPlayer = 8, // cut 8px off each side of player
) => {
  const rx = x2 + padRock;
  const ry = y2 + padRock;
  const rw = rockSize - padRock * 2;
  const rh = rockSize - padRock * 2;

  const px = x1 + padPlayer;
  const py = y1 + padPlayer;
  const pw = playerSize - padPlayer * 2;
  const ph = playerSize - padPlayer * 2;

  return (
    px < rx + rw &&
    px + pw > rx &&
    py < ry + rh &&
    py + ph > ry
  );
};